/**
 * Created by Administrador on 28/03/2018.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('cargoManifest', {
                parent: 'app',
                url: '/cargoManifest',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/manifest/cargoManifest/cargoManifest.html',
                        controller: 'cargoManifestCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabManifestos('cargoManifest')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['generalManifest']);
                            }],
                            airports:['airportService',function(airportService){
                                return airportService.getAirportsActiveDisable(true);
                            }]
                        }
                    }
                }
            });
    }
})();
